import { render, staticRenderFns } from "./DividerSettings.vue?vue&type=template&id=b1af9c78&scoped=true&"
import script from "./DividerSettings.vue?vue&type=script&lang=js&"
export * from "./DividerSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1af9c78",
  null
  
)

export default component.exports